function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/%E2%9D%96-Web-Component-Library?node-id=13773%3A18893
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/button.ts
import { defaultBorder } from "../../utils";
import { space } from "../space";

var solid = _ref => {
  var {
    colorScheme: c
  } = _ref;
  return {
    bg: c + ".500",
    color: 'white',
    _hover: {
      bg: c + ".400"
    },
    _active: {
      bg: c + ".700"
    }
  };
};

var ghost = _ref2 => {
  var {
    colorScheme: c
  } = _ref2;
  return {
    bg: 'transparent',
    color: c + ".500",
    _hover: {
      color: c + ".400"
    },
    _active: {
      color: c + ".700"
    }
  };
};

var outline = _ref3 => {
  var {
    colorScheme: c
  } = _ref3;
  return _extends({}, defaultBorder, {
    borderColor: c + ".500",
    bg: 'white',
    color: c + ".500",
    _hover: {
      borderColor: c + ".400",
      color: c + ".400"
    },
    _active: {
      borderColor: c + ".700",
      color: c + ".700",
      bg: c + ".100"
    }
  });
};

var link = _ref4 => {
  var {
    colorScheme: c
  } = _ref4;
  return {
    color: c + ".500",
    _active: {
      color: c + ".700"
    }
  };
};

var variants = {
  ghost,
  link,
  outline,
  solid
};
export var Button = {
  baseStyle: {
    borderRadius: 'medium'
  },
  sizes: {
    sm: {
      w: 40,
      h: 10
    },
    md: {
      w: space[50],
      h: 12
    }
  },
  variants,
  defaultProps: {
    colorScheme: 'primary',
    size: 'md',
    variant: 'solid'
  }
};
//# sourceMappingURL=Button.js.map